export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Користувача не знайдено"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вибрати"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Закрити"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пошук"])}
}